import { useSelector } from 'react-redux';

import MenuIcon from '~/components/atoms/Icons/MenuIcon';

import { clearRouteAfterLogin } from '~/redux/slices/location';
import { routeAfterLoginSelector } from '~/redux/slices/location/selectors';
import { useAppDispatch } from '~/redux/store/useAppDispatch';
import { MENU_PATH } from '~/routes/paths';
import { useAppHistory } from '~/utilities/routing';

export function MenuButton({ className }: { className: string }): JSX.Element {
  const dispatch = useAppDispatch();
  const history = useAppHistory();
  const routeAfterLogin = useSelector(routeAfterLoginSelector);

  return (
    <MenuIcon
      background={false}
      className={className}
      onClick={() => {
        if (routeAfterLogin) {
          dispatch(clearRouteAfterLogin());
        }
        history.push(MENU_PATH);
      }}
      role="link"
      aria-label="Menu"
    />
  );
}
